import styleInject from './../../../external/.pnpm/style-inject@0.3.0/external/style-inject/dist/style-inject.es.js';

var css_248z = ".app-footer-texts-module_AppFooterTexts__lCE47 {\n  gap: 16px;\n  justify-content: center;\n}\n\n.app-footer-texts-module_textLink__2lI62:hover {\n  cursor: pointer;\n}";
var styles = {"AppFooterTexts":"app-footer-texts-module_AppFooterTexts__lCE47","textLink":"app-footer-texts-module_textLink__2lI62"};
styleInject(css_248z);

export { styles as default };
